export default __webpack_public_path__ + "9f5a693918bae835e0510e209946546b.png";